/**
 * @desc 导出VC报关明细
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.customsDeclarationMaster.exportVcCustomsClearanceDetail.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/exportVcCustomsClearanceDetail`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
